// import service from "@/api/requestITHotline";

// export const queryToken = async (appCode: string) => {
//   const accessToken = localStorage.getItem("token") || JSON.stringify({ [appCode]: "" });
//   let accessTokenJson = { [appCode]: "" };
//   try {
//     accessTokenJson = JSON.parse(accessToken);
//   } catch (e) {
//     console.error(e);
//   }
//   if (!accessTokenJson[appCode]) {
//     const res: any = await service.queryToken(appCode);
//     if (res) {
//       accessTokenJson[appCode] = res.access_token;
//       localStorage.setItem("token", JSON.stringify(accessTokenJson));
//     }
//   }
// };

export const getAccessToken = (appCode: string): string => {
  const accessToken = localStorage.getItem("token") || JSON.stringify({ [appCode]: "" });
  let accessTokenJson = { [appCode]: "" };
  try {
    accessTokenJson = JSON.parse(accessToken);
  } catch (e) {
    console.error(e);
  }
  return accessTokenJson[appCode];
};

export function getCurrentConversation(conversations: any[], key = 'work_current_conversation'): any | undefined {
  const curConversation = localStorage.getItem(key) || 'none';
  if (curConversation === 'none') {
    return undefined;
  } else {
    return conversations.find((conversation) => conversation.id === curConversation);
  }
}

export function setCurrentConversationId(conversationId: string | undefined, key = 'work_current_conversation') {
  if (conversationId) {
    localStorage.setItem(key, conversationId);
  }
}

export function restartConversation(key = 'work_current_conversation') {
  localStorage.removeItem(key);
}

export function getChatHistory(key: string, type: "localStorage" | "sessionStorage" = "sessionStorage") {
  const data = window[type].getItem(key);
  if (data) {
    try {
      return JSON.parse(data);
    } catch (e) {
      return;
    }
  }
}

export function setChatHistory( key: string, data: any, type: "localStorage" | "sessionStorage" = "sessionStorage") {
  try {
    window[type].setItem(key, JSON.stringify(data));
  } catch (e) {
    console.error("setChatHistory error:", e);
  }
}

export function getLocalStorageSize(type: "localStorage" | "sessionStorage" = "sessionStorage") {
  let size = 0;
  for (const key in window[type]) {
      if ( Object.prototype.hasOwnProperty.call(window[type], key) ) {
          size += (JSON.stringify(window[type][key]).length + key.length);
      }
  }
  return size / 1024; // 返回 KB
}